export default {"src":"/_next/static/media/defaultBigUsedCar.0c7ac139.svg","height":125,"width":218};